import { FeedbackConnectorApollo } from '@front-activerse/common-components';
import FeedbackContainer from './FeedbackContainer';

const FeedbackPage = () => {
  return (
    <FeedbackConnectorApollo>
      {({ ...feedbackData }) => <FeedbackContainer {...feedbackData} />}
    </FeedbackConnectorApollo>
  );
};

export default FeedbackPage;
